import type { PropsWithChildren } from "react"
import { WebStorageStateStore } from "oidc-client-ts"
import { AuthProvider as OidcAuthProvider, type AuthProviderProps } from "react-oidc-context"

export function AuthProvider({ children }: PropsWithChildren) {
  const oidc = window.__EYESIGHT_CONFIG__.oidc
  // Derive the redirect URI from the current origin so the OIDC flow works on
  // any host (localhost dev, prod) without baking a single host into config.js.
  // The matching callback/logout URLs must be registered on the Cognito client.
  const redirectUri = window.location.origin + "/auth/callback"
  const props: AuthProviderProps = {
    authority: oidc.authority,
    client_id: oidc.clientId,
    redirect_uri: redirectUri,
    post_logout_redirect_uri: window.location.origin + "/",
    response_type: "code",
    scope: oidc.scope,
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    // Keep the temporary signin state in localStorage too (default is
    // sessionStorage), so it survives the redirect round-trip more robustly.
    stateStore: new WebStorageStateStore({ store: window.localStorage }),
    onSigninCallback: () => {
      // Strip the ?code&state params from the URL (don't leave the auth code in
      // history) but keep the current path. The actual route change to "/" is
      // done by LoginCallback via React Router — replaceState alone would not
      // trigger a navigation and would strand the user on the callback screen.
      window.history.replaceState({}, document.title, window.location.pathname)
    },
  }
  return <OidcAuthProvider {...props}>{children}</OidcAuthProvider>
}
